class AccessCards {
    constructor() {
        this.accessCardDatatable = null;
        this.accessCards = null;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.filter = {};

        this.openCreateAccessCard();
        this.changeTabView();
        this.getAccessCards(true);
        this.enableAccessCards();
        this.initSearchAccessCards();
    }
    openCreateAccessCard(){
        let thisClass = this;
        let createAccessCardButtons = document.querySelectorAll('[data-action="create-access-card"]');
        let firstClick = true;
        createAccessCardButtons.forEach((el) => {
            el.addEventListener('click', function (){
                if(firstClick){
                    new AccessCardsForm('frm-createAccessCardForm-createAccessCardForm', thisClass);
                    firstClick = false;
                }
                bootstrap.Modal.getOrCreateInstance(document.getElementById('create_access_card_modal')).show();
            });
        })
    }
    enableAccessCards(){
        const thisClass = this;
        const checkbox = document.getElementById('accessCardsEnabledCheckbox');
        if(checkbox){
            checkbox.addEventListener('change', (event) => {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let swalText = 'disable';
                    let checked = event.currentTarget.checked;
                    if (checked) {
                        swalText = 'enable';
                    }
                    let swalHtml = `
                        <div class="text-center text-primary">Are you sure you want to <b>`+swalText+`</b> Access Cards?</div>`+
                        (checked && (this.accessCards === null || this.accessCards.length === 0) ?
                            `<div class="text-center text-primary mt-5"><b>Please note:</b> Enabling Access Cards without any settings will prevent Members from accessing all Systems!</div>
                            <div class="form-check mt-5">
                                <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                                <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                                    I agree
                                </label>
                            </div>`
                        : '');
                    Swal.fire({
                        html: swalHtml,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Yes, "+swalText+"!",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                        showLoaderOnConfirm: true,
                        returnFocus: false,
                        preConfirm: () => {
                            let agreeSwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                            if(agreeSwalCheckbox && !agreeSwalCheckbox.checked){
                                Swal.showValidationMessage(`You need to agree`);
                                return;
                            }

                            return fetch('/access-cards?do=enableAccessCards&organizationID='+thisClass.organizationID+'&result='+(checked ? 1 : 0))
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(response.statusText)
                                    }
                                    return response.json();
                                }).catch(error => {
                                    Swal.showValidationMessage(`Request failed: ${error}`)
                                });
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        allowEscapeKey: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value === true){
                                let badge = document.getElementById('access-cards-status-badge');
                                if(checked){
                                    badge.classList.remove('badge-danger');
                                    badge.classList.add('badge-success');
                                    badge.innerText = 'Active';
                                    toastr.success('Access Cards has been successfully enabled!');
                                } else {
                                    badge.classList.remove('badge-success');
                                    badge.classList.add('badge-danger');
                                    badge.innerText = 'Inactive';
                                    toastr.success('Access Cards has been successfully disabled!');
                                }
                            }
                        } else {
                            checkbox.checked = !checked;
                        }
                    });
                }
            });
        }
    }
    changeTabView(){
        const selectedView = KTCookie.get("access_cards_tab_view");
        if(selectedView){
            const tab = document.querySelector('a[data-bs-toggle="tab"][href="'+selectedView+'"]');
            bootstrap.Tab.getOrCreateInstance(tab).show();
        }

        const tabs = document.querySelectorAll('[data-change-tab-view="true"] a[data-bs-toggle="tab"]');
        tabs.forEach((tab) => {
            tab.addEventListener('click', function () {
                const date = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000); // 90 days from now
                KTCookie.set("access_cards_tab_view", tab.attributes.href.value, {expires: date});
            })
        });
    }
    getAccessCards(initialGet = false){
        const thisClass = this;
        if(!initialGet){
            thisClass.initLoading();
        }
        naja.makeRequest('GET', '/access-cards/?do=getAccessCardsData', {
            'organizationID': thisClass.organizationID,
            'filter': JSON.stringify(thisClass.filter)
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                thisClass.accessCards = response.accessCardsData;
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                if(thisClass.accessCards && thisClass.accessCards.length > 0){
                    document.querySelector('div[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                    document.querySelector('#access-card-no-results').classList.add('d-none');
                } else if(!response.showEmptyResults) {
                    document.querySelector('div[data-kt-docs-table-toolbar="base"]').classList.add('d-none');
                    document.querySelector('#access-card-no-results').classList.remove('d-none');
                }

                thisClass.initAccessCardView();
                thisClass.initAccessCardListView(response.showEmptyResults);
                if(!initialGet){
                    thisClass.initLoading();
                }
            }
        });
    }
    initLoading(){
        const cardTab = document.querySelector('#cards_view_tab');
        const tableTab = document.querySelector('#table_view_tab');

        if(cardTab){
            let blockUI = KTBlockUI.getInstance(cardTab);
            if(!blockUI){
                blockUI = new KTBlockUI(cardTab, {
                    overlayClass: "ga-bg-primary-050",
                });
            }
            if (blockUI.isBlocked()) {
                blockUI.release();
            } else {
                blockUI.block();
            }
        }
        if(tableTab){
            let tableLoading = tableTab.querySelector('#access-cards-datatable_loading');
            if(tableLoading.classList.contains('d-none')){
                tableLoading.classList.remove('d-none');
            } else {
                tableLoading.classList.add('d-none');
            }
        }
    }
    initAccessCardView(){
        const thisClass = this;
        const cards = document.querySelectorAll('#cards_view_tab .card.access-card');
        for (let card of cards){
            let deleteButtons = card.querySelectorAll('.delete-access-card');
            deleteButtons.forEach(function (deleteButton) {
                deleteButton.addEventListener('click', function () {
                    thisClass.deleteAccessCard(card.attributes['data-uuid'].value, card.attributes['data-name'].value);
                });
            });

            let switchButtons = card.querySelectorAll('.enable-access-card');
            switchButtons.forEach(function (switchButton) {
                switchButton.addEventListener('change', function () {
                    thisClass.enableAccessCard(card.attributes['data-uuid'].value, card.attributes['data-name'].value, this);
                });
            });
        }
    }
    initAccessCardListView(showEmptyResults){
        const thisClass = this;
        if(!this.accessCardDatatable){
            this.accessCardDatatable = new AccessCardsDatatable(this.organizationID, this.accessCards);
        }

        this.accessCardDatatable.reloadData(this.accessCards, showEmptyResults);

        const accessCardDatatableEl = document.getElementById('access-cards-datatable');
        const deleteButtons = accessCardDatatableEl.querySelectorAll('.delete-access-card');
        deleteButtons.forEach(function (deleteButton) {
            deleteButton.addEventListener('click', function () {
                let datatableAction = deleteButton.closest('.datatable-action');
                let accessCardID = datatableAction.attributes['data-uuid'].value;
                let accessCardName = datatableAction.attributes['data-name'].value;
                thisClass.deleteAccessCard(accessCardID, accessCardName);
            });
        });

        const switchButtons = accessCardDatatableEl.querySelectorAll('.enable-access-card');
        switchButtons.forEach(function (switchButton) {
            switchButton.addEventListener('change', function () {
                let datatableAction = switchButton.closest('.datatable-action');
                let accessCardID = datatableAction.attributes['data-uuid'].value;
                let accessCardName = datatableAction.attributes['data-name'].value;
                thisClass.enableAccessCard(accessCardID, accessCardName, this);
            });
        });
    }
    deleteAccessCard(accessCardID, accessCardName){
        const thisClass = this;
        Swal.fire({
            html: `<span class="text-center text-primary">Are you sure you want to delete `+(accessCardName !== undefined ? `<b>`+accessCardName+`</b>` : `this Access Card?`)+`?</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return fetch('/access-cards/?do=removeAccessCard&organizationID='+thisClass.organizationID+'&accessCardID='+accessCardID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value.status === 'warning') {
                    toastr.error(result.value.message);
                } else if (result.value.status === 'success') {
                    toastr.success(result.value.message);
                }

                this.getAccessCards();
            }
        });
    }
    enableAccessCard(accessCardID, accessCardName, switchButton){
        const thisClass = this;
        let statusText = 'disable';
        if(switchButton.checked){
            statusText = 'enable';
        }
        Swal.fire({
            html: `<span class="text-center text-primary">Are you sure you want to `+statusText+` `+(accessCardName !== undefined ? `<b>`+accessCardName+`</b>` : `this Access Card?`)+`?</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, "+statusText+" it!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return fetch('/access-cards/?do=enableAccessCard&organizationID='+thisClass.organizationID+'&value='+(switchButton.checked ? 1 : 0)+'&accessCardID='+accessCardID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value.status === 'warning') {
                    toastr.error(result.value.message);
                } else if (result.value.status === 'success') {
                    toastr.success(result.value.message);
                }

                this.getAccessCards();
            } else {
                switchButton.checked = !switchButton.checked;
            }
        });
    }
    initSearchAccessCards(){
        this.initFilterAccessCards();

        const thisClass = this;
        let timer; // Timer identifier
        const waitTime = 400; // Set wait time in milliseconds

        // Define the search function
        const search = (text) => {
            thisClass.filter.search = text;
            thisClass.getAccessCards();
        };

        // Attach a `keyup` event listener
        const input = document.querySelector('div[data-kt-docs-table-toolbar="base"] input[data-kt-docs-table-filter="search"]');
        input.addEventListener('keyup', (e) => {
            const text = e.currentTarget.value;

            clearTimeout(timer);

            // Initiate the search request after a delay
            timer = setTimeout(() => {
                search(text);
            }, waitTime);
        });
    }
    initFilterAccessCards(){
        this.initSelect2();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="access-cards-filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
    }
    initSelect2(){
        const optionStatusFormat = function (item) {
            if (!item.id) {
                return item.text;
            }

            const value = item.element.value;
            let span = document.createElement('span');
            if (value === '1') {
                span.classList.add('badge', 'badge-lg', 'badge-light-success', 'position-relative', 'px-4', 'border', 'border-success');
                span.innerText = 'Enabled';
            } else {
                span.classList.add('badge', 'badge-lg', 'badge-light-danger', 'position-relative', 'px-4', 'border', 'border-danger');
                span.innerText = 'Disabled';
            }

            return $(span);
        };
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') + '</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('[data-kt-docs-table-filter=access-cards-members]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=access-cards-systems]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=access-cards-groups]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=access-cards-system-groups]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="access-cards-reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=access-cards-members]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=access-cards-systems]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=access-cards-groups]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=access-cards-system-groups]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=access-cards-enabled]').prop('checked', false);
                $('[data-kt-docs-table-filter=access-cards-disabled]').prop('checked', false);
                $('[data-kt-docs-table-filter=access-cards-time-slot-restrictions]').prop('checked', false);
                $('[data-kt-docs-table-filter=access-cards-temporary-access]').prop('checked', false);

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 0;

        if(reset){
            this.filter = {};
        } else {
            let members = $('[data-kt-docs-table-filter="access-cards-members"]').select2('data');
            let membersArr = [];
            for(const i in members){
                if(members[i].id !== ''){
                    membersArr.push(members[i].id);
                }
            }

            let groups = $('[data-kt-docs-table-filter="access-cards-groups"]').select2('data');
            let groupsArr = [];
            for(const i in groups){
                if(groups[i].id !== ''){
                    groupsArr.push(groups[i].id);
                }
            }

            let systems = $('[data-kt-docs-table-filter="access-cards-systems"]').select2('data');
            let systemsArr = [];
            for(const i in systems){
                if(systems[i].id !== '') {
                    systemsArr.push(systems[i].id);
                }
            }

            let systemGroups = $('[data-kt-docs-table-filter="access-cards-system-groups"]').select2('data');
            let systemGroupsArr = [];
            for(const i in systemGroups){
                if(systemGroups[i].id !== ''){
                    systemGroupsArr.push(systemGroups[i].id);
                }
            }

            let isEnabled = document.querySelector('[data-kt-docs-table-filter="access-cards-enabled"]').checked;
            let isDisabled = document.querySelector('[data-kt-docs-table-filter="access-cards-disabled"]').checked;
            let timeSlotRestrictions = document.querySelector('[data-kt-docs-table-filter="access-cards-time-slot-restrictions"]').checked;
            let temporaryAccess = document.querySelector('[data-kt-docs-table-filter="access-cards-temporary-access"]').checked;

            this.filter.members = membersArr;
            this.filter.groups = groupsArr;
            this.filter.systemGroups = systemGroupsArr;
            this.filter.systems = systemsArr;
            this.filter.isEnabled = isEnabled;
            this.filter.isDisabled = isDisabled;
            this.filter.timeSlotRestrictions = timeSlotRestrictions;
            this.filter.temporaryAccess = temporaryAccess;


            numberOfActiveFilters += membersArr.length;
            numberOfActiveFilters += systemsArr.length;
            numberOfActiveFilters += groupsArr.length;
            numberOfActiveFilters += systemGroupsArr.length;
            numberOfActiveFilters += isEnabled ? 1 : 0;
            numberOfActiveFilters += isDisabled ? 1 : 0;
            numberOfActiveFilters += timeSlotRestrictions ? 1 : 0;
            numberOfActiveFilters += temporaryAccess ? 1 : 0;
        }

        this.getAccessCards();

        $('#accessCardsNumberOfFilters').text(numberOfActiveFilters);
    }
}
window.AccessCards = AccessCards;